import { toast } from "react-toastify";

export const showToast = (
    type,
    title,
    message,
    options = {}
) => {
    const content = (
        <div>
            <strong>{title}</strong>
            <div>{message}</div>
        </div>
    );

    const toastOptions = {
        autoClose: 8000,
        ...options,
    };

    switch (type) {
        case "success":
            return toast.success(content, toastOptions);

        case "warning":
            return toast.warning(content, toastOptions);

        case "info":
            return toast.info(content, toastOptions);

        case "error":
        default:
            return toast.error(content, toastOptions);
    }
};